import dayjs from 'dayjs';
import { Filter } from 'components/molecules';
import { commonTexts } from 'consts/text/index';
import { ApplicationStatus, GetEnrollmentFilterKey } from 'types/enrollment/enrollment';

const statusOptions: { label: string; value: ApplicationStatus }[] = [
    { label: 'Nowy', value: ApplicationStatus.NEW },
    { label: 'Przyjęte', value: ApplicationStatus.APPROVED },
    { label: 'Odrzucone', value: ApplicationStatus.REJECTED },
];

type EnrollmentPageFiltersProps = {
    status?: ApplicationStatus | null;
    fromYear?: number | null;
    toYear?: number | null;
    onChangeFilter?: (filterKey: GetEnrollmentFilterKey, value?: string) => void;
    onChangeFilters?: (filterValues: Partial<Record<GetEnrollmentFilterKey, string>>) => void;
};

export const EnrollmentPageFilters = ({
    status,
    fromYear,
    toYear,
    onChangeFilter,
    onChangeFilters,
}: EnrollmentPageFiltersProps) => (
    <>
        <Filter
            input={
                <Filter.RangePicker
                    picker="year"
                    value={[
                        fromYear ? dayjs().year(fromYear) : null,
                        toYear ? dayjs().year(toYear) : null,
                    ]}
                    onChange={(_, dateStrings) =>
                        onChangeFilters?.({ fromYear: dateStrings[0], toYear: dateStrings[1] })
                    }
                />
            }
            label="Rok szkolny"
            width="15%"
        />
        <Filter
            input={
                <Filter.Select
                    value={status}
                    options={statusOptions}
                    placeholder="Wybierz"
                    onChange={(value) => onChangeFilter?.('status', value)}
                />
            }
            label={commonTexts.dataLabels.status}
            width="15%"
        />
    </>
);
